/*
 * MERCADO 2.0 — search query rewrite for every search form (header, search page, drawer).
 * If the query, normalised (lowercase, no tashkeel/tatweel, unified alef / taa marbuta / alef maqsura,
 * single spaces), exactly matches a curated key, the form submits "<original> OR <target>" so the shopper's
 * words and the catalogue's words both match (Shopify storefront search supports OR and vendor:"…").
 * Map: window.MC2.searchSynonyms, printed by snippets/mc2-search-synonyms.liquid on the search page, and
 * fetched once elsewhere from sections/mc2-search-map.liquid on first focus of a search field.
 * Runs after predictive-search.js's own submit handler (bubbling on document), never when it cancelled.
 */
(function () {
  if (window.MC2 && window.MC2.search) return;
  window.MC2 = window.MC2 || {};

  function normalize(term) {
    return String(term || '')
      .toLowerCase()
      .replace(/[ً-ٰٟ]/g, '')
      .replace(/[آأإٱ]/g, 'ا')
      .replace(/ة/g, 'ه')
      .replace(/ى/g, 'ي')
      .replace(/ـ/g, '')
      .replace(/"/g, '')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function map() { return (window.MC2 && window.MC2.searchSynonyms) || null; }

  function rewrite(q) {
    var m = map();
    if (!m) return null;
    var raw = String(q || '').trim();
    if (!raw || / OR /.test(raw) || /:/.test(raw)) return null; /* already an expression */
    var key = normalize(raw);
    var target = m[key];
    if (!target) return null;
    var original = /\s/.test(raw) ? '"' + raw.replace(/"/g, '') + '"' : raw;
    if (normalize(target) === key) return null;
    return original + ' OR ' + target;
  }

  function isSearchForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    var action = form.getAttribute('action') || '';
    var root = (window.routes && window.routes.search_url) || '/search';
    return action === root || /\/search\/?$/.test(action.split('?')[0]);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!isSearchForm(form) || e.defaultPrevented) return;
    var input = form.querySelector('input[name="q"]');
    if (!input) return;
    var next = rewrite(input.value);
    if (!next) return;
    /* submit a hidden copy so the visible field keeps the shopper's own words (bfcache / back button) */
    e.preventDefault();
    var fd = new FormData(form);
    fd.set('q', next);
    var params = new URLSearchParams();
    fd.forEach(function (v, k) { params.append(k, v); });
    if (!params.has('type')) params.set('type', 'product');
    if (!params.has('options[prefix]')) params.set('options[prefix]', 'last');
    var action = form.getAttribute('action') || '/search';
    window.location.href = action.split('?')[0] + '?' + params.toString();
  }, false);

  /* The map is printed only on the search template. Elsewhere, fetch it once (tiny section render) the first
     time a search field gets focus, so the header form also benefits. */
  var loading = null;
  function loadMap() {
    if (map() || loading) return;
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    loading = fetch(base + '?section_id=mc2-search-map', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = /window\.MC2\.searchSynonyms=(\{[\s\S]*?\});<\/script>/.exec(html || '');
        if (m) { try { window.MC2.searchSynonyms = JSON.parse(m[1]); } catch (err) { /* ignore */ } }
      })
      .catch(function () {});
  }
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (t instanceof HTMLInputElement && t.name === 'q' && t.form && isSearchForm(t.form)) loadMap();
  });

  window.MC2.search = { normalize: normalize, rewrite: rewrite, loadMap: loadMap };
})();
